import React from 'react';
import { Route } from 'react-router-dom';
import { SubscriptionAdminRoute } from '../SubscriptionAdminRoute';
import InvoiceCardPage from '../../Invoice/InvoiceCardPage';
import InvoiceListPage from '../../Invoice/InvoiceListPage';
import CreateInvoicePage from '../../Invoice/CreateInvoicePage';
import CreatePaymentInvoicePage from '../../Invoice/CreatePaymentInvoicePage';
import InvoiceDetailPage from '../../Invoice/InvoiceDetailPage';

const guard = (element) => <SubscriptionAdminRoute element={element} />;

export const invoiceRoutes = [
  <Route key="invoice-hub" path="/invoice" element={guard(<InvoiceCardPage />)} />,
  <Route key="invoice-view" path="/invoice/view" element={guard(<InvoiceListPage />)} />,
  <Route key="invoice-create-service" path="/invoice/create-service-invoice" element={guard(<CreateInvoicePage />)} />,
  <Route key="invoice-create-payment" path="/invoice/create-payment-invoice" element={guard(<CreatePaymentInvoicePage />)} />,
  <Route key="invoice-detail" path="/invoice/:id" element={guard(<InvoiceDetailPage />)} />,
];
